<template>
  <v-layout fill-height column>
    <div class="question" v-html="question"></div>
    <div class="answer">
          <Textarea
              :value="value"
              :height="200"
              :counter="500"
              :placeholder="`최대한 자세히 작성해보세요.`"
              @input="inputChanged"
          />
    </div>
    <FooterBtnsNext  @before="$emit('before')" @next="$emit('next')" :current="current" :total="total" :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import Textarea from "@/components/forms/Textarea"
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"

export default {
  props:{
    current:Number,
    total:Number,
  },
  data: ()=> ({
    question:'몰입경험은 어떠셨나요?<br>떠오르는대로 작성해보세요.',
    value:'',
  }),
  components:{
    Textarea,
    FooterBtnsNext
  },
  computed: {
  },
  methods:{
   inputChanged(input){
     this.value = input;
   },
  }
}
</script>
